export function getStripeKey() {
  // @todo: Need to do the production key
  return process.env.NODE_ENV === 'production'
    ? 'pk_live_3RS2Z7OKHiNl7YGv3cBtSlxD008uhfJwmD'
    : 'pk_test_FSvKkqOagslkYRXbbrCfdPzN00ao6L8jMp';
}
